var _defs, _path, _path2, _g, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPace(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    zoomAndPan: "magnify",
    viewBox: "0 0 75 74.999997",
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "f562a31b90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16 6.234375 L 75 6.234375 L 75 68.484375 L 16 68.484375 Z M 16 6.234375 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 45.960938 33.074219 L 57.636719 21.398438 L 59.847656 23.609375 L 48.171875 35.285156 Z M 45.960938 33.074219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 43.75 43.746094 C 40.304688 43.746094 37.5 40.941406 37.5 37.496094 C 37.5 34.046875 40.304688 31.246094 43.75 31.246094 C 47.199219 31.246094 50.003906 34.046875 50.003906 37.496094 C 50.003906 40.941406 47.199219 43.746094 43.75 43.746094 Z M 43.75 34.371094 C 42.03125 34.371094 40.625 35.773438 40.625 37.496094 C 40.625 39.21875 42.03125 40.621094 43.75 40.621094 C 45.472656 40.621094 46.878906 39.21875 46.878906 37.496094 C 46.878906 35.773438 45.472656 34.371094 43.75 34.371094 Z M 43.75 34.371094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f562a31b90)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 43.75 68.746094 C 32.519531 68.746094 22.097656 62.671875 16.550781 52.894531 L 19.269531 51.351562 C 24.265625 60.15625 33.644531 65.621094 43.753906 65.621094 C 59.261719 65.621094 71.878906 53.003906 71.878906 37.496094 C 71.878906 21.988281 59.261719 9.371094 43.753906 9.371094 C 33.65625 9.371094 24.28125 14.824219 19.285156 23.613281 L 16.570312 22.066406 C 22.121094 12.308594 32.535156 6.246094 43.753906 6.246094 C 60.984375 6.246094 75.003906 20.261719 75.003906 37.496094 C 75.003906 54.726562 60.984375 68.746094 43.753906 68.746094 Z M 43.75 68.746094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 6.25 45.308594 L 26.5625 45.308594 L 26.5625 48.433594 L 6.25 48.433594 Z M 6.25 45.308594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 0 35.933594 L 20.3125 35.933594 L 20.3125 39.058594 L 0 39.058594 Z M 0 35.933594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 6.25 26.558594 L 26.5625 26.558594 L 26.5625 29.683594 L 6.25 29.683594 Z M 6.25 26.558594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPace);
export default __webpack_public_path__ + "static/media/pace.ba6347e77a66aa6618503ce9bd2d4951.svg";
export { ForwardRef as ReactComponent };